import { useMemo } from 'react';

import { useEmbedBootstrap } from '../use-widget-bootstrap';

/**
 * Контекст org/филиала для виджета: как на странице расписания —
 * при нескольких филиалах без `branch_id` в URL нужен выбор филиала.
 */
export function useEmbedOrgBranch() {
  const {
    widgetConfig,
    branchId: branchFromUrl,
    organizationId,
    accessToken,
    guestShowcaseOrg
  } = useEmbedBootstrap();

  const guestBranches = useMemo(
    () => guestShowcaseOrg?.branches ?? [],
    [guestShowcaseOrg]
  );

  const needsBranch = useMemo(() => {
    if (widgetConfig) {
      return widgetConfig.branches && widgetConfig.branches.length > 1 && branchFromUrl == null;
    }
    if (guestShowcaseOrg) {
      return guestBranches.length > 1 && branchFromUrl == null;
    }
    return false;
  }, [widgetConfig, guestShowcaseOrg, guestBranches, branchFromUrl]);

  const effectiveBranchId = useMemo(() => {
    if (widgetConfig) {
      if (widgetConfig.branches?.length <= 1) {
        return widgetConfig.branches[0]?.id ?? null;
      }
      return branchFromUrl;
    }
    if (guestShowcaseOrg) {
      if (guestBranches.length <= 1) {
        return guestBranches[0]?.id ?? null;
      }
      return branchFromUrl;
    }
    return branchFromUrl;
  }, [widgetConfig, guestShowcaseOrg, guestBranches, branchFromUrl]);

  return {
    widgetConfig,
    guestShowcaseOrg,
    organizationId,
    accessToken,
    branchFromUrl,
    needsBranch,
    effectiveBranchId
  };
}
